import * as React from 'react'

// Components
import Svg from './..'

const SnowflakeCool = (props) => {
  return (
    <Svg fill="none" viewBox="0 0 12 14" {...props}>
      <path
        d="M11.665 8.268l-1.503.402-1.29-.734V6.064l1.29-.734 1.503.403L12 4.478l-1.141-.305.296-1.151-1.244-.338-.4 1.515-1.29.734-1.58-.936V2.528l1.103-1.111L6.83.5l-.832.839L5.165.5l-.916.917 1.103 1.111v1.469l-1.612.936-1.29-.734-.374-1.515-1.238.338.303 1.15L0 4.479l.335 1.255 1.503-.403 1.29.734v1.879l-1.29.734-1.503-.403L0 9.529l1.141.305-.303 1.144 1.245.338.4-1.514 1.29-.735 1.579.936v1.469l-1.103 1.111.916.917.832-.839.832.839.909-.917-1.096-1.111v-1.469l1.612-.943 1.29.735.399 1.514 1.212-.331-.303-1.15 1.142-.306zm-7.28-2.204l1.612-.943 1.612.943v1.872l-1.612.943-1.612-.943z"
        fill="#3ce967"
      />
    </Svg>
  )
}

export default SnowflakeCool
